import { Fragment, useState, useEffect, useRef } from 'react'
import './login.css'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { useAuth } from '../core/Auth'
import { useIsMobile } from '../../../../utils/hooks/useIsMobile'
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { getUserByToken, login } from '../core/_requests'
import * as AuthService from '../../../../services/auth'
import ReCAPTCHA from 'react-google-recaptcha'

const initialValues = {
  email: '',
  g_recaptcha_response: '',
}

export function ForgotPassword() {
  const recaptchaRef = useRef<ReCAPTCHA | null>(null)
  const [loading, setLoading] = useState(false)
  const isMobile = useIsMobile()
  const [isAlumni, setIsAlumni] = useState(true)
  const formik = useFormik({
    initialValues,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true)
      try {
        const data = await AuthService.forgotPassword({ email: values.email, g_recaptcha_response: values.g_recaptcha_response })
        setLoading(false)
        toast('Silahkan cek email, dan ikuti petunjuk yang ada pada email')
      } catch (error) {
        console.error(error)
        setStatus('The login details are incorrect')
        setSubmitting(false)
        setLoading(false)
      }
    },
  })

  useEffect(() => {
    if (isAlumni) {
      localStorage.removeItem('role')
    } else {
      localStorage.setItem('role', 'company')
    }
  }, [isAlumni])

  return (
    <Fragment>
      <div
        className='side-one bg-image'
        style={{
          backgroundImage: `url(${require('../../../../assets/img/bg-company.png')})`,
        }}
      >
        <div className='image-small'>
          <img src={require('../../../../assets/img/bg-company.png')} />
        </div>
      </div>
      <div className='side-two'>
        <div className='form-container'>
          <img src={require('../../../../assets/img/login-logo.png')} className='login-logo' />
          <p className='fontsize-42 fontweight-600 mt-5 mb-8'>
            Reset Password <br />
          </p>

          <form className='input-container' onSubmit={formik.handleSubmit}>
            <label className='input-label'>Email</label>
            <input type='email' {...formik.getFieldProps('email')} className='input-form' />

            <div className='space-between mb-30'>
              <p>
                <Link to={'/auth'} className='color-orange fontweight-600'>
                  Login?
                </Link>
              </p>
            </div>

            <div className='mb-10'>
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey='6Lf3qh8qAAAAAAmCYQOBXog8koATjbM4w7HZBGo2'
                onChange={(value) => formik.setFieldValue('g_recaptcha_response', value)}
                onExpired={() => {
                  formik.setFieldValue('g_recaptcha_response', '')
                  toast.error('Captcha expired, silakan centang ulang.')
                }}
              />

              {formik.touched.g_recaptcha_response && formik.errors.g_recaptcha_response && (
                <div className='text-danger small mt-1'>{formik.errors.g_recaptcha_response}</div>
              )}
            </div>

            <button className='button mb-5' disabled={formik.isSubmitting || !formik.isValid}>
              {loading ? 'Loading ...' : 'Reset Password'}
            </button>

            <p className='text-center fontsize-14 mb-5'>
              <p>
                Belum Punya Akun?{' '}
                <Link to={'/company-register'} className='link-primary'>
                  Daftar di sini
                </Link>
              </p>
            </p>

            <p className='text-center fontsize-14 color-grey mt-20' style={{ maxWidth: '500px' }}>
              Tidak ada bagian dari situs web ini atau isinya yang boleh direproduksi, disalin,
              dimodifikasi atau diadaptasi, tanpa persetujuan tertulis sebelumnya dari LPDP.
            </p>
          </form>
        </div>
      </div>
    </Fragment>
  )
}
